import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { Helmet } from 'react-helmet'
import { get } from 'tiny-compose-fns/noFp'

import { Box } from 'system'
import { DevRefreshButton } from '../components/DevRefreshButton'
import { SkipNavLink } from '../components/SkipNavLink'

export const Layout = ({ children, headless = false, ...props }) => {
  const queryData = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  return (
    <>
      <Helmet
        titleTemplate={`%s – ${get('site.siteMetadata.title', queryData)}`}
        defaultTitle={get('site.siteMetadata.title', queryData)}
      >
        <meta
          name="description"
          content={get('site.siteMetadata.description', queryData)}
        />
      </Helmet>
      <SkipNavLink />
      {!headless && process.env.NODE_ENV === 'development' && (
        <DevRefreshButton />
      )}
      <Box as="main" position="relative" {...props}>
        {children}
      </Box>
    </>
  )
}
